import {remCalc} from '_themeUtils'

const stickyBanner = {
    StickyBanner: {
        baseStyle: ({backgroundColor, colorContent, bottomPos}) => ({
            wrapper: {
                bg: backgroundColor && backgroundColor.length ? backgroundColor : 'color.background.white',
                position: 'fixed',
                w: '100%',
                bottom: 0,
                zIndex: 'banner',
                borderStyle: 'solid',
                borderWidth: {base: 'spacing.1', lg: remCalc(3)},
                borderColor: backgroundColor && backgroundColor.length ? backgroundColor : 'color.background.white',
            },

            btnClose: {
                position: 'absolute',
                top: remCalc(5),
                right: remCalc(10),
                w: remCalc(30),
                h: remCalc(30),
                minH: remCalc(30),
                minW: remCalc(30),
                maxH: remCalc(30),
                maxW: remCalc(30),
            },

            container: {
                gap: 'spacing.0',
                color: colorContent && colorContent.length ? colorContent : 'color.text.black',
                flexWrap: 'wrap',
            },

            title: {
                textStyle: {base: 'paragraphLg', md: 'displaySm'},
                fontWeight: '400',
            },

            subtitle: {
                textStyle: 'paragraphMd',
                fontWeight: '300',
                my: 'spacing.1',
                display: {base: 'none', sm: 'block'},
            },

            header: {
                width: {base: '100%', md: '50%'},
                flex: {md: '0 0 50%'},
                py: {base: 'spacing.1', xl: 0},
                pl: {base: 'spacing.4', xl: remCalc(60)},
                pr: {base: 'spacing.6', xl: 'spacing.5'},
                textAlign: 'left',
                alignItems: 'flex-start',
                gap: 'spacing.0',
            },

            info: {
                gap: 'spacing.0',
                width: {base: '55%', md: '65%', xl: `calc(100%*2/3 - ${remCalc(240)})`},
                flex: {base: '0 0 55%', md: '0 0 65%', xl: `0 0 calc(100%*2/3 - ${remCalc(240)})`},
            },

            cta: {
                w: {base: '100%', xl: 'size.button.md'},
                mt: {base: 'spacing.1.5', xl: 'auto'},
                ml: {base: 0, xl: 'auto'},
                mr: {base: 0, xl: 'spacing.px'},
                mb: {base: 0, xl: 'spacing.6'},
                flex: {xl: '0 0 size.button.md'},
                pr: {base: 0, xl: 'spacing.12'},

                a: {
                    color: backgroundColor && backgroundColor.length ? backgroundColor : 'color.text.button.primary.default',
                    backgroundColor: colorContent && colorContent.length ? colorContent : 'color.background.primary.default',
                    _hover: {
                        color: backgroundColor && backgroundColor.length ? backgroundColor : 'color.text.button.primary.hover',
                        backgroundColor: colorContent && colorContent.length ? colorContent : 'color.background.primary.hover',
                    },
                },
            },

            body: {
                width: {base: '100%', md: '50%'},
                flex: {md: '0 0 50%'},
                py: {base: 0, md: 'spacing.2', xl: 'spacing.4'},
                pr: {base: 'spacing.6', xl: remCalc(60)},
                pl: {base: 'spacing.5', md: remCalc(5), xl: 'spacing.10'},
                alignItems: 'center',
                textAlign: 'center',

                fontWeight: 300,
            },

            countdownContainer: {
                mr: {base: 'spacing.6', sm: 0},
            },

            countdownWrapper: {
                m: 0,
                pr: {base: 'spacing.8', sm: 0},
            },

            countdown: {
                display: 'block',
                fontWeight: '300',
                textStyle: 'paragraphXl',
                fontSize: {base: remCalc(18), lg: remCalc(22), xl: remCalc(30)},
                lineHeight: {base: remCalc(26), lg: remCalc(26), xl: remCalc(36)},
                minH: {base: remCalc(26), lg: remCalc(26), xl: remCalc(36)},
                color: 'color.text.black',
                textAlign: {base: 'left', sm: 'center'},
                whiteSpace: 'nowrap',
                letterSpacing: {base: '0.5px', lg: '3px', xl: '5px'},
                m: 0,
                p: 0,
                py: {base: 'spacing.2', sm: 0},
                opacity: 1,
            },

            text: {
                textStyle: 'paragraphSm',
                textAlign: 'left',
                display: {base: 'none', sm: 'block'},
            },

            image: {
                width: {base: '45%', md: '35%', xl: `calc(100%/3 - ${remCalc(120)})`},
                flex: {base: '0 0 45%', md: '0 0 35%', xl: `0 0 calc(100%/3 - ${remCalc(120)})`},
            },
        }),
    },
}
export default stickyBanner
